import React from 'react';

interface LaporLambeButtonProps {
  className?: string;
  phone?: string; // WhatsApp phone number, default Lambe Turah number
  text?: string;  // Pre-filled message
  position?: 'bl' | 'br' | 'tl' | 'tr'; // bottom-left, bottom-right, top-left, top-right
  iconSrc?: string; // Custom icon path
  iconAlt?: string;
}

const DEFAULT_PHONE = '62812123200';
const DEFAULT_TEXT = 'Halo Lambe Turah News! Saya ingin melaporkan gossip hangat yang menarik. Berikut detailnya:';

const positionClasses: Record<NonNullable<LaporLambeButtonProps['position']>, string> = {
  bl: 'fixed bottom-2 left-3 md:bottom-3',
  br: 'fixed bottom-2 right-3 md:bottom-3',
  tl: 'fixed top-3 left-3',
  tr: 'fixed top-3 right-3',
};

const LaporLambeButton: React.FC<LaporLambeButtonProps> = ({
  className = '',
  phone = DEFAULT_PHONE,
  text = DEFAULT_TEXT,
  position = 'bl',
  iconSrc = '/img/LaporLambe.png',
  iconAlt = 'Lapor Lambe',
}) => {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;

  return (
    <a
      className={`group cursor-pointer hover:scale-115 ${positionClasses[position]} p-3 transition-all duration-300 z-40 ${className}`}
      aria-label="Lapor Lambe"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={iconSrc} alt={iconAlt} className="w-32 md:w-48" />
    </a>
  );
};

export default LaporLambeButton;
